import { CButton, CRow, CCol, CCard, CCardBody, CCardText, CCardTitle, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CFormSelect, CFormInput, CFormText, CFormCheck, CContainer, CCardHeader } from '@coreui/react'
import { CNav, CNavItem, CNavLink, CTabContent, CTabPane, CFormTextarea, CWidgetStatsC } from '@coreui/react'
import React, { useEffect } from 'react'
import CIcon from '@coreui/icons-react'
import { cilChartPie } from '@coreui/icons'
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css'
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker'
import Patient from './Patient'

import './Patient.css'
import { Button } from 'antd'
import { useState, useRef } from 'react'
import CustomAgGrid from './../../components/shared/CustomAgGrid'

import { Form, Formio } from '@formio/react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'

import GetKeywords from '../../services/general/getKeywords.api'

import Select from 'react-select'

// import {AddPatientForm} from './constants'

import AddPatientForm from './AddNewPatient'

import MyCalendar from './Calendar'

import SaveKareo from '../../services/general/syncKareo.api'

import SavePatientData from '../../services/general/savePatientData.api.js'
import GetPatientsData from '../../services/general/getPatientsData.api.js'
import SaveQuestionBank from '../../services/general/saveQuestionBank.api'
import GetPatientDiagnosisDetails from '../../services/general/getPatientDiagnosisDetails.api'
import SelectOrg from './../../components/shared/SelectOrg'
import ManageDynamicForm from '../../services/general/manageDynamicForms.api'
import SetPatientDiagnosis from '../../services/general/setPatientDiagnosis.api'

const PatientDashboard = () => {
  const [showPracticeOptions, setPracticeOptions] = useState(true)
  const dateFormat = 'DD/MM/YYYY'
  const [textInput, setTextInput] = useState('')

  const handleInputChange = (event) => {
    setTextInput(event.target.value)
  }
  const buttonList = [{ Name: 'View' }, { Name: 'Edit' }]
  const [dateVisible, setDateVisible] = useState(false)
  const [patientID, setPatientID] = useState('')
  const [loading, setLoading] = useState(false)

  const kareoDate = useRef({ from: '', to: '' })

  const [patientDetailsVisible, setPatientDetailsVisible] = useState(false)
  const renderedFormData = useRef([])
  function boldKeywordsRenderer(text) {
    // Get the text content of the element
    // Define a list of keywords to make bold
    //      const keywords = ['Major', 'Minor', 'test','yes','Yes'];

    // Replace the keywords with bolded versions
    keyWords.forEach((keyword) => {
      text = text.replaceAll(keyword, `<strong>${keyword}</strong>`)
    })

    return text
  }

  const handleRenderComplete = (e) => {
    // const reactElement = React.createElement(e.element.type, e.element.props);
    // setHtmlObject(reactElement)
    //formHTML.current = e.element
    //const formElements = document.getElementsByTagName('form');
    // debugger;
    // let jsonData = e.getInnerHTML()
    //formHTML.current.innerHTML = html
    // jsonData = jsonData.replaceAll("1","<b>1</b>")
    //formHTML.current.innerHTML = formHTML.current.innerHTML + jsonData
    // // Perform additional actions here
  }

  const [keyWords, setKeyWords] = useState([])
  const [selectedDayRange, setSelectedDayRange] = useState({
    from: null,
    to: null,
  })

  const formHTML = useRef('')
  const [diagnosisData, setDiagnosisData] = useState([])
  var selectedDiagnosis = []

  const onDateChange = (f, l) => {
    kareoDate.current['from'] = f
    kareoDate.current['to'] = l
  }

  const [allSelectedDiagnosis, setAllSelectedDiagnosis] = useState([])
  const [activeKey, setActiveKey] = useState(1)
  const [formAnswers, setFormAnswers] = useState([])
  const [diagnosisQuestions, setDiagnosisQuestions] = useState([])

  const patientSelected = async (type, rowSelected) => {
    if (type == 'EDIT') {
      setPatientID(rowSelected.IDNumber)
      let c = await SetPatientDiagnosis('SELECT', patientID.toString(), '')
      try {
        let newData = JSON.parse(c.d)
        let diagnosis = newData.Data[0].Diagnosis
        let tempSelectedDiagnosis = diagnosis.split(',')
        selectedDiagnosis = diagnosisData.filter((obj) => {
          if (tempSelectedDiagnosis.includes(obj.label)) {
            return obj
          }
        })
        setAllSelectedDiagnosis(selectedDiagnosis)
      } catch (e) {
        setAllSelectedDiagnosis([])
        console.log('Error', e)
      }
      setModalVisible(true)
    } else {
      let diagnosisList = rowSelected.Diagnosis?.split(',').map((obj) => {
        return obj.trim()
      })
      let newComponents = []
      for (let a = 0; a < diagnosisList.length; a++) {
        //formAnswers[a] = {}
        try {
          let c = await SaveQuestionBank('', diagnosisList[a], '')
          //let c= await axios(config)
          let component = JSON.parse(c.d)
          newComponents.push(component)
        } catch (e) {}
      }
      let tempAnswers = await GetPatientDiagnosisDetails(rowSelected.IDNumber)
      try {
        let data = JSON.parse(tempAnswers.d)
        let formAnswersStr = data.Data[0].DiagnosisDetails

        formAnswersStr = boldKeywordsRenderer(formAnswersStr)
        //formAnswersStr = formAnswersStr.replaceAll("1","<b>1</b>")
        let tempData = JSON.parse(formAnswersStr)
        setFormAnswers(tempData)
        setDiagnosisQuestions(newComponents)
        setPatientDetailsVisible(true)
      } catch (e) {
        console.log('Error In everything', e)
      }
    }
  }

  const [jsonSchema, setJsonSchema] = useState({ component: [] })

  const [patientData, setPatientData] = useState('')

  const patientDataFn = async () => {
    let patientData = await GetPatientsData('')
    setPatientData(patientData.d)
    let keywords = await GetKeywords('SELECT', '')
    keywords = JSON.parse(keywords.d).Data.map((obj) => {
      return obj.Keyword
    })

    setKeyWords(keywords)
  }
  const getData = async () => {
    let a = await GetDiagnosisData()
    let data = JSON.parse(a.d)
    let options = []
    data.Data.map((obj) => {
      options.push({
        value: obj.id,
        label: obj.Name.trim(),
      })
    })
    setDiagnosisData(options)
    let form = await ManageDynamicForm('Patient', '', 'admin', 'select')
    if (form.d == '') {
      setJsonSchema({ components: [] })
    } else {
      let temp = JSON.parse(form.d)
      setJsonSchema(temp)
    }
  }

  const [modalVisible, setModalVisible] = useState(false)

  var mysubmission = ''
  const title = useRef('')
  const [state, setState] = useState(null)
  // const formRef = React.useRef(null);
  // const onFormReady = React.useCallback(async (form) => {
  //   formRef.current = form;
  // }, []);
  var allData = {}
  const myForm = useRef(null)
  const handleonClick = (e) => {
    setModalVisible((e) => !e)
  }

  const saveDiagnosisData = async () => {
    let allDiagnosis = selectedDiagnosis
      .map((obj) => {
        return obj.label
      })
      .join(',')
    await SetPatientDiagnosis('UPDATE', patientID.toString(), allDiagnosis)
    await patientDataFn()
    setModalVisible(false)
  }
  const formData = async () => {
    let diagnosis = ''
    diagnosis = selectedDiagnosis
      .map((obj) => {
        return obj.label
      })
      .join(',')
    let newDate = new Date(allData.dateOfBirth)
    let a = await SavePatientData(allData.firstName + ' ' + allData.middleName + ' ' + allData.lastName, allData.phoneNumber, newDate.toLocaleDateString(), allData.poaname, allData.poaphonenumber, diagnosis)

    patientDataFn()
    setModalVisible(false)
  }
  const formioOptions = {
    readOnly: true,
    renderMode: 'html',
  }

  useEffect(() => {
    getData()
    patientDataFn()
  }, [])

  const formatDate = (newDate) => {
    const yyyy = newDate.getFullYear()
    let mm = newDate.getMonth() + 1 // Months start at 0!
    let dd = newDate.getDate()

    if (dd < 10) dd = '0' + dd
    if (mm < 10) mm = '0' + mm

    const formattedToday = dd + '/' + mm + '/' + yyyy

    return formattedToday
  }

  const syncKareo = async (e) => {
    setLoading(true)
    if (selectedDayRange && selectedDayRange['from'] != '') {
      let fmDate = selectedDayRange['from']?.day.toString() + '/' + selectedDayRange['from']?.month.toString() + '/' + selectedDayRange['from']?.year.toString()
      let toDate = selectedDayRange['to']?.day.toString() + '/' + selectedDayRange['to']?.month.toString() + '/' + selectedDayRange['to']?.year.toString()
      let a = await SaveKareo('', fmDate, toDate)
      location.reload()
    } else {
      alert('Please select From Date and To Date')
    }

    setLoading(false)
  }
  return (
    <>
      <Patient></Patient>
    </>
  )
}

const AddButton = () => {
  return (
    <>
      <CButton style={{ marginLeft: '10px' }} variant="outline" color="success">
        ADD +
      </CButton>
    </>
  )
}

export default PatientDashboard
